import { useTranslation } from "react-i18next";

const heroBg =
  "https://readdy.ai/api/search-image?query=Modern%20luxury%20steel%20frame%20residential%20architecture%20exterior%20at%20twilight%2C%20dramatic%20contemporary%20house%20with%20clean%20geometric%20lines%2C%20floor-to-ceiling%20glass%20windows%20glowing%20warm%20light%2C%20landscaped%20garden%20foreground%2C%20premium%20architectural%20photography%2C%20warm%20cream%20and%20charcoal%20tones%2C%20editorial%20quality%2C%20professional%20real%20estate%20imagery%20with%20soft%20shadows%20on%20light%20background&width=1600&height=900&seq=11&orientation=landscape";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[70vh] md:min-h-[75vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={heroBg} alt="現代高端鋼構住宅外觀" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-b from-graphite/70 via-graphite/55 to-graphite/80" />
      </div>

      <div className="relative z-10 w-full container-main px-4 md:px-8 lg:px-12 py-28 md:py-36">
        <div className="max-w-3xl">
          <span className="tag-label mb-5 inline-block">{t("portfolio.hero.label")}</span>
          <h1 className="text-white mb-5">{t("portfolio.hero.title")}</h1>
          <p className="text-cream/90 mb-8 max-w-2xl">{t("portfolio.hero.subtitle")}</p>
          <a
            href="https://lin.ee/OpssTIM"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary gap-2 inline-flex"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-line-fill" />
            </span>
            {t("portfolio.hero.cta")}
          </a>
        </div>
      </div>
    </section>
  );
}